/**
 * Sentiment colors aligned with BarChartWrapper stacked bars and Welcome metric 14 API.
 */
const SENTIMENT_LABEL_TO_KEY = {
  positive: "positive",
  negative: "negative",
  neutral: "neutral",
  mixed: "mixed",
  unspecified: "unspecified",
};

const SENTIMENT_RGBA_BY_KEY = {
  positive: "rgba(16, 200, 0, 0.8)",
  negative: "rgba(220, 37, 37, 1)",
  neutral: "rgba(255, 255, 0, 0.8)",
  mixed: "rgba(255, 152, 0, 0.8)",
  unspecified: "rgba(224, 131, 17, 0.664)",
};

export function sentimentLabelToStackedBarRgba(label, opacity = 0.8) {
  const key = SENTIMENT_LABEL_TO_KEY[String(label ?? "").trim().toLowerCase()];
  if (!key) {
    return `rgba(128, 128, 128, ${opacity})`;
  }
  const rgba = SENTIMENT_RGBA_BY_KEY[key];
  if (!rgba) {
    return `rgba(128, 128, 128, ${opacity})`;
  }
  if (opacity === 0.8) {
    return rgba;
  }
  const match = rgba.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
  if (!match) {
    return rgba;
  }
  return `rgba(${match[1]}, ${match[2]}, ${match[3]}, ${opacity})`;
}
